import {LinkButton, Text} from '@yandex-delivery/blocks'
import React from 'react'
import type {ContentActionButtonItem} from 'src/api/types'

import {classes} from './ActionButton.styles'

type Props = {
  item: ContentActionButtonItem
}

/**
 * Извлекает URL из action_payload.
 * Поддерживаемые action: open_universal_link (url), deeplink (deeplink).
 */
function getActionUrl(item: ContentActionButtonItem): string | undefined {
  const action = item.action_payload?.action
  if (!action) {
    return undefined
  }
  return action.url ?? action.deeplink
}

/**
 * Кнопка-действие внутри content-секции (item type: 'action_button').
 * Используется в bottom_content_sections для кнопки оплаты «Оплатить · N ₽».
 */
export const ActionButton: React.FC<Props> = ({item}) => {
  const url = getActionUrl(item)

  if (!url) {
    return null
  }

  return (
    // @ts-expect-error React version mismatch between workspaces — аналогично AccentButton
    <LinkButton alignItems="center" fullWidth href={url} newTab variant="action">
      <Text align="center" className={classes.label}>
        {item.title.text}
      </Text>
    </LinkButton>
  )
}
